import Immutable from 'immutable';
import {isMobile} from 'utils';
import {ActionTypes as SearchActionTypes} from 'store/search/actions';
import {ActionTypes} from './actions';

// Reducer -----------------------------------------------------------------------------------------

export const initial = Immutable.fromJS({
    width: 0,
    compact: false,
    entityMenuOpened: false,
    entityTypeIndex: -1,
    heatmapTooltipIndex: -1,
    heatmapTooltipExpandedIndex: -1,
    heatmapTooltipAnimation: true,
    settingsOpened: false,
    shareOpened: false,
    downloadOpened: false,
    downloadTranscriptFormat: 'txt',
    downloadTranscriptFormats: [{value: 'txt', label: 'TXT'}],
    downloadCaptionFormat: null,
    downloadCaptionFormats: [],
    downloadLoading: false,
    printLoading: false,
});

export const reducer = (state = initial, action) => {
    switch (action.type) {
        case ActionTypes.SET_WIDTH:
            return state.merge({
                width: action.width,
                compact: isMobile() || action.width <= 420,
                heatmapTooltipExpandedIndex: -1,
            });

        case ActionTypes.TOGGLE_ENTITY_MENU:
            const entityMenuOpened = !state.get('entityMenuOpened');
            return state.merge({
                entityMenuOpened,
                entityTypeIndex: !entityMenuOpened ? -1 : state.get('entityTypeIndex'),
            });

        case ActionTypes.CLOSE_ENTITY_MENU:
            return state.merge({
                entityTypeIndex: -1,
                entityMenuOpened: false,
            });

        case ActionTypes.TOGGLE_ENTITY_TYPE:
            const index = action.entityType.get('index');
            return state.set('entityTypeIndex', index === state.get('entityTypeIndex') ? -1 : index);

        case ActionTypes.SHOW_HEATMAP_TOOLTIP:
            const heatmapTooltipAnimation = state.get('heatmapTooltipIndex') === -1;
            return state.merge({
                heatmapTooltipIndex: action.block.get('index'),
                heatmapTooltipExpandedIndex: -1,
                heatmapTooltipAnimation,
            });

        case ActionTypes.HIDE_HEATMAP_TOOLTIP:
            return state.merge({
                heatmapTooltipIndex: -1,
                heatmapTooltipExpandedIndex: -1,
                heatmapTooltipAnimation: true,
            });

        case ActionTypes.EXPAND_HEATMAP_TOOLTIP:
            return state.set('heatmapTooltipExpandedIndex', action.block.get('index'));

        case SearchActionTypes.SET_RESULTS:
        case SearchActionTypes.CLEAR:
            return state.set('heatmapTooltipExpandedIndex', -1);

        case ActionTypes.TOGGLE_SETTINGS_DIALOG:
            return state.merge({
                settingsOpened: !state.get('settingsOpened'),
                shareOpened: false,
                downloadOpened: false,
            });

        case ActionTypes.TOGGLE_SHARE_DIALOG:
            return state.merge({
                shareOpened: !state.get('shareOpened'),
                settingsOpened: false,
                downloadOpened: false,
            });

        case ActionTypes.TOGGLE_DOWNLOAD_DIALOG:
            return state.merge({
                downloadOpened: !state.get('downloadOpened'),
                shareOpened: false,
                settingsOpened: false,
            });

        case ActionTypes.SET_CAPTION_FORMATS:
            const inititalValues = {
                downloadCaptionFormat: initial.get('downloadCaptionFormat'),
                downloadCaptionFormats: initial.get('downloadCaptionFormats'),
            };

            if (!action.captions) return state.merge(inititalValues);

            const formats = Immutable.fromJS([
                ...action.captions.get(action.language).map(format => ({
                    value: format.get('format'),
                    label: format.get('format').toUpperCase(),
                })),
            ]);

            return state.merge({
                downloadCaptionFormats: formats,
                downloadCaptionFormat: formats.get(0).get('value'),
            });

        case ActionTypes.SET_CAPTION_FORMAT:
            return state.merge({downloadCaptionFormat: action.format});

        case ActionTypes.SET_TRANSCRIPT_FORMAT:
            return state.merge({downloadTranscriptFormat: action.format});

        case ActionTypes.TOGGLE_PRINT_LOADING:
            return state.set('printLoading', !state.get('printLoading'));

        case ActionTypes.TOGGLE_DOWNLOAD_LOADING:
            return state.set('downloadLoading', !state.get('downloadLoading'));

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./scripts/store/ui/reducer.js